/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { Pageable } from './';
import {
    PageableFromJSON,
    PageableFromJSONTyped,
    PageableToJSON,
} from './';

/**
 * 
 * @export
 * @interface ClientCompanyTeamSearchRequest
 */
export interface ClientCompanyTeamSearchRequest {
    /**
     * 
     * @type {Pageable}
     * @memberof ClientCompanyTeamSearchRequest
     */
    page: Pageable;
    /**
     * 
     * @type {string}
     * @memberof ClientCompanyTeamSearchRequest
     */
    search: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ClientCompanyTeamSearchRequest
     */
    companyIds: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ClientCompanyTeamSearchRequest
     */
    organizationId?: string;
}

/**
 * Check if a given object implements the ClientCompanyTeamSearchRequest interface.
 */
export function instanceOfClientCompanyTeamSearchRequest(value: object): value is ClientCompanyTeamSearchRequest {
    if (!('page' in value) || value['page'] === undefined) return false;
    if (!('search' in value) || value['search'] === undefined) return false;
    if (!('companyIds' in value) || value['companyIds'] === undefined) return false;
    return true;
}

export function ClientCompanyTeamSearchRequestFromJSON(json: any): ClientCompanyTeamSearchRequest {
    return ClientCompanyTeamSearchRequestFromJSONTyped(json, false);
}

export function ClientCompanyTeamSearchRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClientCompanyTeamSearchRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'page': PageableFromJSON(json['page']),
        'search': json['search'],
        'companyIds': json['companyIds'],
        'organizationId': json['organizationId'] == null ? undefined : json['organizationId'],
    };
}

export function ClientCompanyTeamSearchRequestToJSON(value?: ClientCompanyTeamSearchRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'page': PageableToJSON(value['page']),
        'search': value['search'],
        'companyIds': value['companyIds'],
        'organizationId': value['organizationId'],
    };
}

